// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"86ca667a","703":"c2b9f0be"}[chunkId] + ".chunk.js";
};